import { SliceCaseReducers } from '@reduxjs/toolkit'

export const reducerCreatorProducer =
  <S>() =>
  <R extends SliceCaseReducers<S>>(reducers: R) =>
    reducers
